export default {
  'pages.layouts.userLayout.title':
    'طراحی مورچه تأثیرگذارترین مشخصات طراحی وب در منطقه Xihu است',
  'pages.login.accountLogin.tab': 'ورود به حساب کاربری',
  'pages.login.accountLogin.errorMessage':
    'نام کاربری / رمزعبور نادرست (مدیر / ant.design)',
  'pages.login.failure':
    'ورود به سیستم با شکست مواجه شد، لطفا دوباره سعی کنید!',
  'pages.login.success': 'ورود موفق!',
  'pages.login.username.placeholder': 'نام کاربری: مدیر یا کاربر',
  'pages.login.username.required': 'لطفا نام کاربری خود را وارد کنید!',
  'pages.login.password.placeholder': 'رمز عبور: ant.design',
  'pages.login.password.required': 'لطفاً رمز ورود خود را وارد کنید!',
  'pages.login.phoneLogin.tab': 'ورود به سیستم تلفن',
  'pages.login.phoneLogin.errorMessage': 'خطای کد تأیید',
  'pages.login.phoneNumber.placeholder': 'شماره تلفن',
  'pages.login.phoneNumber.required': 'لطفاً شماره تلفن خود را وارد کنید!',
  'pages.login.phoneNumber.invalid': 'شماره تلفن نامعتبر است!',
  'pages.login.captcha.placeholder': 'کد تایید',
  'pages.login.captcha.required': 'لطفا کد تأیید را وارد کنید!',
  'pages.login.phoneLogin.getVerificationCode': 'دریافت کد',
  'pages.getCaptchaSecondText': 'ثانیه',
  'pages.login.rememberMe': 'مرا به خاطر بسپار',
  'pages.login.forgotPassword': 'رمز عبور را فراموش کرده اید ?',
  'pages.login.submit': 'ارسال',
  'pages.login.loginWith': 'وارد شوید با :',
  'pages.login.registerAccount': 'ثبت نام',
  'pages.welcome.link': 'خوش آمدید',
  'pages.welcome.alertMessage': 'اجزای سنگین تر سریعتر و قوی تر آزاد شده اند.',
  'pages.404.subTitle': 'ببخشيد، صفحه اي که ديديد وجود نداره',
  'pages.404.buttonText': 'بازگشت به صفحه اصلی',
  'pages.admin.subPage.title': 'این صفحه فقط توسط مدیر قابل مشاهده است',
  'pages.admin.subPage.alertMessage':
    'رابط کاربری Umi اکنون منتشر شده است ، برای شروع تجربه استفاده از npm run ui خوش آمدید.',
  'pages.searchTable.createForm.newRule': 'قانون جدید',
  'pages.searchTable.updateForm.ruleConfig': 'پیکربندی قانون',
  'pages.searchTable.updateForm.basicConfig': 'اطلاعات اولیه',
  'pages.searchTable.updateForm.ruleName.nameLabel': ' نام قانون',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'لطفاً نام قانون را وارد کنید!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'شرح قانون',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'لطفاً حداقل پنج حرف وارد کنید',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'لطفاً حداقل یک قانون حاوی پنج کاراکتر شرح دهید!',
  'pages.searchTable.updateForm.ruleProps.title': 'پیکربندی خصوصیات',
  'pages.searchTable.updateForm.object': 'نظارت بر شی',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'الگوی قانون',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'نوع قانون',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'تنظیم دوره زمان بندی',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'زمان شروع',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'لطفاً زمان شروع را انتخاب کنید!',
  'pages.searchTable.titleDesc': 'شرح',
  'pages.searchTable.ruleName': 'نام قانون لازم است',
  'pages.searchTable.titleCallNo': 'تعداد تماس های خدماتی',
  'pages.searchTable.titleStatus': 'وضعیت',
  'pages.searchTable.nameStatus.default': 'پیش فرض',
  'pages.searchTable.nameStatus.running': 'در حال دویدن',
  'pages.searchTable.nameStatus.online': 'برخط',
  'pages.searchTable.nameStatus.abnormal': 'غیرطبیعی',
  'pages.searchTable.titleUpdatedAt': 'آخرین برنامه ریزی در',
  'pages.searchTable.exception': 'لطفا دلیل استثنا را وارد کنید!',
  'pages.searchTable.titleOption': 'گزینه',
  'pages.searchTable.config': 'پیکربندی',
  'pages.searchTable.subscribeAlert': 'مشترک شدن در هشدارها',
  'pages.searchTable.title': 'فرم درخواست',
  'pages.searchTable.new': 'جدید',
  'pages.searchTable.chosen': 'انتخاب شده',
  'pages.searchTable.item': 'مورد',
  'pages.searchTable.totalServiceCalls': 'تعداد کل تماس های خدماتی',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'حذف دسته ای',
  'pages.searchTable.batchApproval': 'تصویب دسته ای',
  
  // Order Statistics Page
  'pages.orders.statistics.title': 'آمار سفارشات',
  'pages.orders.statistics.dateRange': 'بازه تاریخ',
  'pages.orders.statistics.last7Days': '۷ روز گذشته',
  'pages.orders.statistics.last30Days': '۳۰ روز گذشته',
  'pages.orders.statistics.last90Days': '۹۰ روز گذشته',
  'pages.orders.statistics.totalOrders': 'تعداد کل سفارشات',
  'pages.orders.statistics.totalSales': 'مبلغ فروش',
  'pages.orders.statistics.refundCount': 'تعداد کالاهای مسترد شده',
  'pages.orders.statistics.refundAmount': 'مبلغ مسترد شده',
  'pages.orders.statistics.trendChart': 'نمودار روند تجاری',
  'pages.orders.statistics.dailyStats': 'آمار روزانه',
  'pages.orders.statistics.chart.orders': 'سفارشات',
  'pages.orders.statistics.chart.revenue': 'درآمد',
  'pages.orders.statistics.chart.refunds': 'بازپرداخت‌ها',
  'pages.orders.statistics.table.date': 'تاریخ',
  'pages.orders.statistics.table.orderCount': 'تعداد سفارش',
  'pages.orders.statistics.table.revenue': 'درآمد',
  'pages.orders.statistics.table.refundCount': 'تعداد بازپرداخت',
  'pages.orders.statistics.table.refundAmount': 'مبلغ بازپرداخت',
  'pages.orders.statistics.table.total': 'مجموع {total} مورد',

  // تنظیمات تخفیف زنده
  'pages.live.rebate.title': 'تنظیمات تخفیف زنده',
  'pages.live.rebate.liveTeamName': 'نام تیم زنده',
  'pages.live.rebate.memberId': 'شناسه عضو',
  'pages.live.rebate.sellerId': 'شناسه فروشنده',
  'pages.live.rebate.sellerPercent': 'فروشنده %',
  'pages.live.rebate.companyPercent': 'شرکت %',
  'pages.live.rebate.teamPercent': 'تیم %',
  'pages.live.rebate.teamRebatePercent': 'تخفیف تیم %',
  'pages.live.rebate.settingTimeAdmin': 'زمان تنظیم / مدیر',
  'pages.live.rebate.actions': 'عملیات',
  'pages.live.rebate.setting': 'تنظیم',
  'pages.live.rebate.detail': 'جزئیات',
  'pages.live.rebate.delete': 'حذف',
  'pages.live.rebate.addRebate': 'افزودن تخفیف',
  'pages.live.rebate.batchUpdate': 'به‌روزرسانی دسته‌ای',
  'pages.live.rebate.selectFirst': 'لطفاً ابتدا موارد را انتخاب کنید',
  'pages.live.rebate.addSuccess': 'تخفیف با موفقیت اضافه شد',
  'pages.live.rebate.addFailed': 'افزودن تخفیف ناموفق بود',
  'pages.live.rebate.updateSuccess': 'تخفیف با موفقیت به‌روزرسانی شد',
  'pages.live.rebate.updateFailed': 'به‌روزرسانی تخفیف ناموفق بود',
  'pages.live.rebate.deleteSuccess': 'تخفیف با موفقیت حذف شد',
  'pages.live.rebate.deleteFailed': 'حذف تخفیف ناموفق بود',
  'pages.live.rebate.deleteConfirm': 'حذف تخفیف',
  'pages.live.rebate.deleteContent': 'آیا مطمئن هستید که می‌خواهید این تنظیم تخفیف را حذف کنید؟',
  'pages.live.rebate.addModalTitle': 'افزودن تنظیم تخفیف',
  'pages.live.rebate.editModalTitle': 'ویرایش تنظیم تخفیف',
  'pages.live.rebate.liveTeamNameRequired': 'لطفاً نام تیم زنده را وارد کنید',
  'pages.live.rebate.memberIdRequired': 'لطفاً شناسه عضو را وارد کنید',
  'pages.live.rebate.sellerIdRequired': 'لطفاً شناسه فروشنده را وارد کنید',
  'pages.live.rebate.sellerPercentRequired': 'لطفاً درصد فروشنده را وارد کنید',
  'pages.live.rebate.companyPercentRequired': 'لطفاً درصد شرکت را وارد کنید',
  'pages.live.rebate.teamPercentRequired': 'لطفاً درصد تیم را وارد کنید',
  'pages.live.rebate.teamRebatePercentRequired': 'لطفاً درصد تخفیف تیم را وارد کنید',
  'pages.live.rebate.loadFailed': 'بارگذاری تنظیمات تخفیف ناموفق بود',
  'pages.live.rebate.selectAtLeastTwo': 'لطفاً حداقل ۲ مورد انتخاب کنید',
  'pages.live.rebate.batchSetting': 'تنظیم دسته‌ای',
  'pages.live.rebate.batchUpdateTitle': 'به‌روزرسانی دسته‌ای درصدها',
  'pages.live.rebate.selectedItems': 'مورد انتخاب شده',
  'pages.live.rebate.applySetting': 'اعمال تنظیم',
  'pages.live.rebate.cancel': 'لغو',
  'pages.live.rebate.batchUpdateSuccess': 'به‌روزرسانی دسته‌ای با موفقیت انجام شد',
  'pages.live.rebate.batchUpdateFailed': 'به‌روزرسانی دسته‌ای ناموفق بود',
  'pages.live.rebate.searchLabel': 'جستجو',
  'pages.live.rebate.searchPlaceholder': 'جستجو بر اساس نام تیم زنده، شناسه فروشنده یا شناسه عضو',
  'pages.live.rebate.search': 'جستجو',
  'pages.live.rebate.reset': 'بازنشانی',
  'pages.live.rebate.teamLead': 'رهبر تیم',
  'pages.live.rebate.teamLeadId': 'شناسه رهبر تیم',
  'pages.live.rebate.teamLeadIdRequired': 'لطفاً شناسه رهبر تیم را وارد کنید',
  'pages.live.rebate.teamInternalSelfPercent': 'داخلی تیم خود %',
  'pages.live.rebate.teamInternalSelfPercentRequired': 'لطفاً درصد داخلی تیم خود را وارد کنید',
  'pages.live.rebate.teamInternalUplinePercent': 'داخلی تیم بالادستی %',
  'pages.live.rebate.teamRebate': 'تخفیف تیم',
  'pages.live.rebate.memberSettings': 'تنظیمات اعضا',
  'pages.live.rebate.memberSettingsTitle': 'تنظیمات تخفیف هر فروشنده',
  'pages.live.rebate.memberSettingsHint': 'درصد تخفیف هر فروشنده را تنظیم کنید. مقادیر ذخیره‌شده جایگزین تنظیمات تیم برای آن فروشنده می‌شوند؛ فروشندگان «تنظیم‌نشده» از تنظیمات تیم استفاده می‌کنند.',
  'pages.live.rebate.memberSource': 'منبع',
  'pages.live.rebate.memberSourceTeamCopy': 'کپی از تیم',
  'pages.live.rebate.memberSourceAdmin': 'تنظیم جداگانه',
  'pages.live.rebate.memberSourceNone': 'تنظیم‌نشده (تنظیمات تیم)',
  'pages.live.rebate.memberSourceTeamConfig': 'تنظیمات تیم',
  'pages.live.rebate.memberSelfPercent': '٪ خود',
  'pages.live.rebate.memberSave': 'ذخیره',
  'pages.live.rebate.memberSaveSuccess': 'تنظیمات تخفیف فروشنده ذخیره شد',
  'pages.live.rebate.memberSaveFailed': 'ذخیره تنظیمات تخفیف فروشنده ناموفق بود',
  'pages.live.rebate.memberLoadFailed': 'بارگیری اعضای تیم ناموفق بود',
  'pages.live.rebate.marginSumError': 'مجموع ٪ فروشنده + شرکت + تیم باید ۱۰۰ باشد',
  'pages.live.rebate.teamLeadTag': 'سرپرست تیم',
  'pages.live.rebate.teamInternalUplinePercentRequired': 'لطفاً درصد داخلی تیم بالادستی را وارد کنید',
  'pages.live.rebate.configuredAt': 'زمان پیکربندی',
  'pages.live.rebate.configuredAtRequired': 'لطفاً زمان پیکربندی را انتخاب کنید',
  'pages.live.sellers.userId': 'شناسه کاربری',
  'pages.live.sellers.sellerId': 'شناسه فروشنده',
  'pages.live.sellers.name': 'نام',
  'pages.live.sellers.recommender': 'معرف',
  'pages.live.sellers.team': 'تعداد تیم',
  'pages.live.sellers.follower': 'دنبال‌کننده',
  'pages.live.sellers.salesAmount': 'مبلغ فروش',
  'pages.live.sellers.salesCount': 'تعداد فروش',
  'pages.live.sellers.rebate': 'تخفیف انباشته',
  'pages.live.sellers.refundAmount': 'مبلغ بازگشت',
  'pages.live.sellers.rebateDeduction': 'کسر تخفیف',
  'pages.live.sellers.liveStatus': 'وضعیت زنده',
  'pages.live.sellers.liveStatus.live': 'زنده',
  'pages.live.sellers.liveStatus.idle': 'بیکار',
  'pages.live.sellers.homepage': 'صفحه اصلی',
  'pages.live.sellers.homepageLink': 'لینک',
  'pages.live.sellers.actions': 'عملیات',
  'pages.live.rebate.levelDetailTitle': 'لیست تیم زنده',
  'pages.live.rebate.levelDetail.column.teamName': 'نام تیم',
  'pages.live.rebate.levelDetail.column.depth': 'سطح',
  'pages.live.rebate.levelDetail.column.userUniqueId': 'شناسه فروشنده',
  'pages.live.rebate.levelDetail.column.userId': 'شناسه کاربر',
  'pages.live.rebate.levelDetail.column.userName': 'نام کاربر',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': 'تعداد زیرمجموعه',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': 'مبلغ فروش (KRW)',
  'pages.live.rebate.levelDetail.column.marginAmountKrw': 'مبلغ حاشیه (KRW)',
  'pages.live.rebate.levelDetail.column.salesQuantity': 'تعداد فروش',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': 'مبلغ بازپرداخت (KRW)',
  'pages.live.rebate.levelDetail.column.refundQuantity': 'تعداد بازپرداخت',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': 'ری‌بیت تیم انباشته (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': 'ری‌بیت تیم کسر شده (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': 'ری‌بیت تیم پس از بازپرداخت (KRW)',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': 'شرکت انباشته (KRW)',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': 'شرکت کسر شده (KRW)',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': 'شرکت پس از بازپرداخت (KRW)',
  'pages.live.rebate.levelDetail.column.action': 'عملیات',
  'pages.live.rebate.levelDetail.searchLabel': 'جستجو:',
  'pages.live.rebate.levelDetail.searchPlaceholder': 'جستجو بر اساس شناسه فروشنده، شناسه کاربر یا نام کاربر...',
  'pages.live.rebate.levelDetail.searchButton': 'جستجو',
  'pages.live.rebate.levelDetail.resetButton': 'بازنشانی',
  'pages.live.rebate.levelDetail.reloadButton': 'بارگذاری مجدد',
  'pages.live.rebate.levelDetail.detailButton': 'جزئیات',
  'pages.live.rebate.levelDetail.loadError': 'بارگذاری داده‌های جزئیات تخفیف زنده ناموفق بود',
  'pages.live.rebate.levelDetail.level1': 'سطح ۱',
  'pages.live.rebate.levelDetail.level2': 'سطح ۲',
  'pages.live.rebate.levelDetail.level3': 'سطح ۳',
  'pages.live.rebate.levelDetail.level4': 'سطح ۴',
};
